<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/mouse-events-have-key-events -->
<div class="menu-navs" [ngClass]="{'disableElement': IsDisableHeader}">
  <div class="row nav-2">
    <div class="col-8">
       <ul>
      <li *ngFor="let link of listMenu; let i = index">
        <a  (click)="goMainLink(link)" (mouseout)="showSelected()"
   [ngClass]="{'disableWhenClick': isButtonDisable && link.label === 'Queue','disableElement': IsDisablemenu && link.label === 'Queue',active: link.isselected}">
          <img alt="" class="menu-icon" src="{{ link.imgpath }}" alt="Italian Trulli" />{{ link.label }}
          <div class="new-tab" *ngIf="link.label === 'Reporting Dashboard'">
            <img alt="" src="{{ baseHref }}/assets/images/icon-new-window.svg" />
          </div>
        </a>
      </li>
    </ul>
    </div>
    <div class="col-4">
      <div class="login-date-inline" [ngClass]="{'float-left' : getShowDialerStatus(), '' : !getShowDialerStatus() }">
         {{ loginDate | date: "MM-dd-yyyy h:mm a"}}
    </div>
      <div class="internet-speed-inline" [class.shifted]="isPredictiveopened()" *ngIf="showInternetSpeed">
      <ng-container *ngIf="isSpeedLoading; else speedReady">
        <div class="speed-bars loading" title="Measuring speed...">
          <span class="bar bar-1"></span>
          <span class="bar bar-2"></span>
          <span class="bar bar-3"></span>
        </div>
        <span class="speed-loading-text">Measuring...</span>
      </ng-container>
      <ng-template #speedReady>
        <div class="speed-bars" [ngClass]="getSpeedClass()" [title]="getSpeedClass() + ': ' + internetSpeed + ' Mbps'">
          <span class="bar bar-1"></span>
          <span class="bar bar-2"></span>
          <span class="bar bar-3"></span>
        </div>
        {{ internetSpeed }} Mbps
      </ng-template>
    </div>
    <div style="clear: both;"></div>
    </div>
    <!--(mouseover)="showMenus(i)"-->
  </div>

  <div class="nav-3" *ngIf="menus && menus.length > 0">
    <div class="inside-nav3-heading" *ngIf="listMenu[selectedListIndex].label === 'Console'">Manage:</div>
    <ng-container *ngFor="let menu of menus; let j = index">
      <div
        class="inside-nav3-heading"
        [ngClass]="{ uactive: menu.isselected, disable: menu.isdisabled, 'disableWhenClick': isButtonDisable, '': !isButtonDisable }" 
        (click)="selectMenu(j,'')"
        (mouseout)="showSelected()"
      >
        {{ menu.label }}
      </div>
    </ng-container>
    <!-- (mouseover)="showSubMenus(menu)"-->
  </div>

  <div class="nav-4" *ngIf="subMenus && subMenus.length > 0">
    <ng-container *ngFor="let submenu of subMenus; let k = index">
      <div
        class="inside-nav3-heading"
        [ngClass]="{ uactive: submenu.isselected, disable: submenu.isdisabled }"
        (click)="selectSubMenu(k)"
        (mouseout)="showSelected()"
      >
        {{ submenu.label }}
      </div>
    </ng-container>
  </div>
</div>
